import { render, staticRenderFns } from "./PublishPatentDemand.vue?vue&type=template&id=ff5b9544&scoped=true"
import script from "./PublishPatentDemand.vue?vue&type=script&lang=js"
export * from "./PublishPatentDemand.vue?vue&type=script&lang=js"
import style0 from "./PublishPatentDemand.vue?vue&type=style&index=0&id=ff5b9544&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5b9544",
  null
  
)

export default component.exports